<template>
  <v-card class="elevation-12">
    <v-toolbar color="primary" dark flat>
      <v-toolbar-title>{{$t('Login.LoginComponent.title')}}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-text-field
        v-model="login"
        :label="$t('Login.LoginComponent.login')"
        name="login"
        prepend-icon="person"
        type="text"
        required
      ></v-text-field>
      <v-text-field
        v-model="password"
        id="password"
        :label="$t('Login.LoginComponent.password')"
        name="password"
        prepend-icon="lock"
        type="password"
        required
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="mb-3" color="primary" @click="register">{{$t('Login.LoginComponent.register')}}</v-btn>
      <v-btn class="mb-3 mr-3" color="primary" @click="submit">{{$t('Login.LoginComponent.submit')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

import tokenStore from "../../store/TokenStore";

export default {
  props: {
    source: String
  },
  data() {
    return {
      login: "",
      password: ""
    };
  },
  methods: {
    submit: function() {
      axios
        .post(process.env.VUE_APP_API_ADDR + "/api/auth/login", {
          login: this.login,
          password: this.password
        })
        .then(res => {
          if (res.data.success) {
            tokenStore.setToken(res.data.token);
            this.$emit("logged");
          }
        })
        .catch(err => {
          try {
            switch (err.response.data.errorMessage) {
              default:
                this.$emit("alert", this.$t("Login.Alert.api-error"));
                break;
              case "Utilisateur incorrect":
                this.$emit("alert", this.$t("Login.Alert.bad-username"));
                break;
              case "Mail incorrect":
                this.$emit("alert", this.$t("Login.Alert.bad-mail"));
                break;
              case "Mot de passse incorrect":
                this.$emit("alert", this.$t("Login.Alert.bad-password"));
                break;
            }
          } catch {
            this.$emit("alert", this.$t("Login.Alert.api-error"));
          }
        });
    },
    register: function() {
      this.$emit("register");
    }
  }
};
</script>